import { get } from 'lodash-es';

export const cwid = (expose: any) => get(expose, 'cwid');
export const companyName = (expose: any) => get(expose, 'companyName');
export const badges = (expose: any) => get(expose, 'badges', []);
export const website = (expose: any) => get(expose, 'website');
export const proRealtorImageUrl = (expose: any) =>
  get(expose, 'proRealtor.imageUrl');
export const proRealtorAboutUsText = (expose: any) =>
  get(expose, 'proRealtor.aboutUsText');
